import { useContext, useState } from "react";
import { useAsyncEffect } from "../../../hooks/UseAsyncEffect";
import { AccountContext } from "../AccountContext";
import { CreateOrUpdateRegularPayment } from "./CreateOrUpdateRegularPayment";
import { ProjectedPayment } from "./ProjectedPayment";
import { RegularPayment } from "./RegularPayment";
import { RegularPaymentHistory } from "./RegularPaymentHistory";
import { RegularPaymentPaymentHistory } from "./RegularPaymentPaymentHistory";
import { OpenJobs } from "./scheme/OpenJobs";

export function RegularPayments() {
  const { accountId, regularPaymentService, setError, billingDate } = useContext(AccountContext);
  const [loading, setLoading] = useState(true as boolean);
  const [regularPayment, setRegularPayment] = useState(undefined as any);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(undefined as any);

  async function fetchData() {
    const response = await regularPaymentService.getRegularPayments(accountId);
    setRegularPayment(response);
    setLastUpdatedDate(new Date());
  }

  useAsyncEffect(async () => {
    try {
      setLoading(true);
      fetchData();
    } catch (error) {
      setError({ source: "Get Regular Payments", ...error });
    } finally {
      setLoading(false);
    }
  }, [accountId]);

  function delayedFetchData(delay: number = 500)
  {
    setTimeout(async () => {
      await fetchData();
    }, delay);
  }

  return (
      <section>          
      {loading && <div className="ui active centered inline loader" />}
      {!loading ?
        <div className="ui grid">
          <div className="three wide column">
                <CreateOrUpdateRegularPayment regularPayment={regularPayment} onSubmit={() => delayedFetchData(1000)} />
          </div>
          <div className="ten wide column">
            <RegularPayment regularPayment={regularPayment} onCancel={() => {
              setRegularPayment(undefined);
              setLastUpdatedDate(billingDate)
            }} />
            <div className="ui divider" />
            <ProjectedPayment lastUpdatedDate={lastUpdatedDate}/>
            <div className="ui divider" />
            <RegularPaymentPaymentHistory lastUpdatedDate={lastUpdatedDate}/>
            <div className="ui divider" />
            <RegularPaymentHistory lastUpdatedDate={lastUpdatedDate}/>
          </div>
          <div className="three wide column">
            <OpenJobs onJobRun={() => delayedFetchData()} />
          </div>
        </div> : null}
    </section>
  )
}